import { roundToPlaces } from "../../utils/roundToPlaces.js";
import type { CourseType } from "../CourseType.js";
import type { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";
import type { TaxedPrice } from "../TaxedPrice.js";
import { courseTypeContentMap } from "../names/courseTypeContentMap.js";
import { calculatePriceWithoutTax } from "./calculatePriceWithoutTax.js";
import { courseVatRate } from "./courseVatRate.js";
import { resolveExchangeRate } from "./resolveExchangeRate.js";

export function calculateCourseOrderPrice(
	type: CourseType,
	currency: Currency,
	exchangeRates: ExchangeRate[],
): TaxedPrice {
	const exchangeRate = resolveExchangeRate(currency, exchangeRates);
	const withTax = roundToPlaces(courseTypeContentMap[type].priceWithTax / exchangeRate, 2);
	return {
		withTax,
		withoutTax: calculatePriceWithoutTax(withTax, courseVatRate),
		taxRate: courseVatRate,
	};
}
